import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PropTypes from "prop-types";
// material ui core
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CssBaseline from "@material-ui/core/CssBaseline";

// Style
import { withStyles } from "@material-ui/core/styles";
import subscriptionCommon from "../Subscription/common";
import basketUtil from "../Subscription/basket";

class BasketForm extends React.Component {
  Licences = () => {
    const { basket, classes, orderState, handleChange, subs } = this.props;
    if (orderState.deployTheBot) {
      const fiksedLicences = basketUtil.getFiksedLicenses(basket, orderState.deployTheBot, orderState.licenses);
      const ctrl = (
        <div>
          <TextField
            id="numberOfLicences"
            disabled={true}
            className={classes.textField}
            label=""
            margin="normal"
            onChange={handleChange}
            value={fiksedLicences}
            inputProps={{ min: 0, maxLength: 3, inputMode: "numeric", size: 3, style: { textAlign: "center" } }}
          />
        </div>
      );
      return (
        <FormControlLabel
          disabled
          control={ctrl}
          label="How many licenses would you like to purchase?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
          labelPlacement="start"
        />
      );
    } else {
      const ctrl = (
        <div>
          <TextField
            id="numberOfLicences"
            className={classes.textField}
            label=""
            margin="normal"
            onChange={handleChange}
            value={orderState.numberOfLicences}
            inputProps={{ min: 0, maxLength: 3, inputMode: "numeric", size: 3, style: { textAlign: "center" } }}
          />
        </div>
      );
      return (
        <FormControlLabel
          control={ctrl}
          label="How many licenses would you like to purchase?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
          labelPlacement="start"
        />
      );
    }
  };

  AddLicences = () => {
    const { classes, orderState, handleChange, subs } = this.props;
    // const addon = _.find(subs.addon, x => { if(x.)})
    // if(subs.addons && subs.addons.count > 0)
    return (
      <div>
        <TextField
          id="addNumberOfLicences"
          className={classes.textField}
          label=""
          margin="normal"
          onChange={handleChange}
          value={orderState.addNumberOfLicences}
          inputProps={{ min: 0, maxLength: 3, inputMode: "numeric", size: 3, style: { textAlign: "center" } }}
        />
      </div>
    );
  };

  DeployBot = () => {
    const { handleCheckboxChange, orderState } = this.props;

    return (
      <Checkbox
        id="deployTheBot"
        color="secondary"
        name="saveCard"
        onChange={handleCheckboxChange}
        checked={orderState.deployTheBot}
      />
    );
  };

  BasketFormRender = () => {
    const { orderState } = this.props;
    let AddLicencesCtrl = () => {
      return <div />;
    };
    if (orderState.deployTheBot) {
      AddLicencesCtrl = () => (
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <FormControlLabel
              control={this.AddLicences()}
              label="How many additional licenses would you like to purchase?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
              labelPlacement="start"
            />
          </Grid>
        </Grid>
      );
    }
    return (
      <React.Fragment>
        <CssBaseline>
          <Typography variant="h5" gutterBottom>
            Subscription options
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              {this.Licences()}
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <FormControlLabel
                control={this.DeployBot()}
                label="Do you want to deploy the bot to an external website?"
                labelPlacement="start"
              />
            </Grid>
          </Grid>
          {AddLicencesCtrl()}
        </CssBaseline>
      </React.Fragment>
    );
  };

  render() {
    return this.BasketFormRender();
  }
}

BasketForm.propTypes = {};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

BasketForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(BasketForm);

export default withStyles(subscriptionCommon.styles)(BasketForm);
